import VueRouter from 'vue-router'
import Vue from 'vue'

import lists from './lists'
import notFoundRoute from './404'

Vue.use(VueRouter)

const routes = [
  ...lists.routes,
  ...notFoundRoute.routes
]
const router = new VueRouter({ routes })

router.afterEach((to, from) => {
  const title = to.meta.title
  document.title = title
})

export default router



// WEBPACK FOOTER //
// ./examples/router/index.js